import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid
} from '@material-ui/core';
import Popup from 'components/popup/popup';
import PasswordTextField from 'components/Input/PasswordTextField';
import { SYSTEM_HANDLE_FORCE_CHECK_VALIDATION } from 'store/key';
import { useDispatch } from 'react-redux';
import API from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
        flex: 1,
        overflow: 'auto'
    },
    title: {
        fontWeight: 'bold'
    },
    item: {
        marginTop: theme.spacing(2)
    },
}));

export default function ResetPassword(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const rowData = props.rowData ? props.rowData : null;

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [passwordValid, setPasswordValid] = useState(true);
    const [confirmPasswordValid, setConfirmPasswordValid] = useState(true);
    const [forceShowError, setForceShowError] = useState(false);

    const confirm = () => {
        setForceShowError(true);
        if (passwordValid && confirmPasswordValid) {
            setGlobalLoading(true);
            const data = {
                confirmPassword: confirmPassword,
                password: password,
                userid: rowData.id,
            };
            API.userAccount.updatePassword(data)
                .then(() => {
                    props.setWarningMsg({
                        message: props.systemMessage.updateCodeSuccess,
                        footerActions: [
                            {
                                label: 'Confirm',
                                clicked: () => {
                                    props.setWarningMsg(null);
                                },
                            },
                        ],
                    });

                    props?.onPasswordUpdated?.();
                    cancel();

                })
                .finally(() => setGlobalLoading(false));
        };
    };

    const cancel = () => {
        props.setOpenPopup(false);
    };
    const reset = () => {
        setPassword('');
        setConfirmPassword('');
        dispatch({
            type: SYSTEM_HANDLE_FORCE_CHECK_VALIDATION,
            payload: {
                forceCheckValidation: true,
            },
        });
    };
    return (
        <Popup height="40%" width="25%" title="Reset Password" open={props.openPopup} footerActions={[
            { label: 'Cancel', clicked: cancel, color: 'default' },
            { label: 'Reset', clicked: reset },
            { label: 'Confirm', clicked: confirm },
        ]} closePopup={cancel}>
            <Grid container wrap="nowrap" direction="column" className={classes.container}>
                <Grid container direction="column" className={classes.item}>
                    <PasswordTextField
                        name="password"
                        label="Password"
                        value={password}
                        handleChange={e => setPassword(e.target.value)}
                        validators={['isRequired', 'disableChinese', 'checkPassword']}
                        isValidValue={valid => setPasswordValid(valid)}
                        forceErrorDisplay={forceShowError}
                    />
                </Grid>
                <Grid container direction="column" className={classes.item}>
                    <PasswordTextField
                        name="confirmPassword"
                        label="Confirm Password"
                        value={confirmPassword}
                        handleChange={e => setConfirmPassword(e.target.value)}
                        validators={['isRequired', 'disableChinese', 'checkConfirmPassword']}
                        isValidValue={valid => setConfirmPasswordValid(valid)}
                        forceErrorDisplay={forceShowError}
                        confirmPasswordNotMatchPassword={confirmPassword !== password}
                    />
                </Grid>
            </Grid>
        </Popup>
    );
}
